var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgVideoTabSelected = function SvgVideoTabSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.391 8.196V5.647a.935.935 0 00-.278-.682 1.033 1.033 0 00-.702-.298H2.647a1.033 1.033 0 00-.703.298.935.935 0 00-.278.682v9.804a.935.935 0 00.278.682c.184.184.436.291.703.298H14.41c.266-.007.519-.114.702-.298a.935.935 0 00.278-.682V12.9l2.058 2.47a.5.5 0 00.884-.32V6.047a.5.5 0 00-.884-.32L15.39 8.196z",
    fill: "url(#VideoTabSelected_svg__vgp6aip0ra)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.166 7.167h5m1.429 0h1.071",
    stroke: "#fff",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "VideoTabSelected_svg__vgp6aip0ra",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.8353 9.14877 -11.52472 7.35074 4.164 7.283)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })))));
};
export default SvgVideoTabSelected;